export default __webpack_public_path__ + "static/mad-scientist-2348bb11336bb6968ecb4fb7aa8f4acb.svg";